var exports = {
  "iE": "VoiceChannelUserCount.module__wrapper___S1hQc2",
  "VV": "VoiceChannelUserCount.module__users___S1hQc2",
  "X5": "VoiceChannelUserCount.module__total___S1hQc2",
};

module.exports = exports;
